import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { useHeader } from '../Header/useHeader';

interface Props {
  isPrint?: boolean;
}

export const Legend = ({ isPrint }: Props) => {
  const { isFetching, data } = useHeader();

  if (isFetching || !data) {
    return null;
  }

  return (
    <Box mt="16">
      <Text fontSize={isPrint ? 'extraSmall' : 'body'} color="neutral.500" as="p">
        Monte Carlo is a process that is used to conduct a statistical analysis of a client’s
        portfolio to determine the probability of the client achieving their retirement goal. The
        investment returns for each year are calculated from the return of each asset class for that
        year and the asset allocation of each account. Asset class returns are generated from a
        random distribution. Each asset class is linked to an index, or a set of indices, with an
        assumed mean return and standard deviation. Using a correlation matrix between all the asset
        classes, and assuming a normal distribution of returns, we generate random returns for each
        year of the simulation. We run {data.trialsCount} trials each time using a different set of
        asset class returns taken from the distribution. At the end of the simulation, we calculate
        the percentage of trials in which the client was able to cover all of their expenses until
        the end of their retirement. This is the probability of success.
      </Text>
      <Text fontSize={isPrint ? 'extraSmall' : 'body'} color="neutral.500" mt="16" as="p">
        IMPORTANT: The projections or other information generated by this Monte Carlo simulation
        regarding the likelihood of various investment outcomes are hypothetical in nature, do not
        reflect actual investment results and are not guarantees of future results. There is no
        guarantee that the results generated by this simulation will be achieved or sustained, and
        results may vary with each use. Please note: This analysis must be reviewed in conjunction
        with the limitations and conditions described in the Disclosure section of this
        presentation. Projections are based on assumptions provided by you and your
        advisor/representative, and are not guaranteed. Actual results will vary, perhaps to a
        significant degree. The projected reports are hypothetical in nature and for illustrative
        purposes only.
      </Text>
    </Box>
  );
};
